export const stringify = (data: unknown) => {
  if (typeof data === "boolean") return data ? "true" : ""
  if (typeof data === "object") return JSON.stringify(data)
  if (typeof data === "number") return data.toString()
  return data
}
export const getItem = (key: string) => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(key)
  }
  return null
}
export const setItem = (key: string, value: string) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, value)
  }
}
export const removeItem = (key: string) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key)
  }
}
